import SendInvitesDialog from './component'
export default SendInvitesDialog
